import { isVisManager } from 'utils/visManager'
import { CANADA_DOMAIN, USA, CANADA } from '../../translations'

const SKIP_ERROR_MESSAGES = ['Twilio 53118 - Room completed']
const MONITOR_PATH = '/monitor'

function shouldSkip(err) {
  return SKIP_ERROR_MESSAGES.includes(err) || SKIP_ERROR_MESSAGES.includes(err.message)
    || SKIP_ERROR_MESSAGES.includes(err.toString())
}

function isMonitor() {
  return window.location.hash.includes(MONITOR_PATH)
}

function getDefaultAttributes() {
  const isCanada = location.hostname.endsWith(CANADA_DOMAIN)
  return {
    visitURL: location.href,
    visitCountry: isCanada ? CANADA : USA
  }
}

export function noticeError(err, customAttributes) {
  if (shouldSkip(err) || isMonitor()) return
  if (typeof newrelic !== 'undefined') {
    const prefix = isVisManager() ? 'VisMgr: ' : 'VisNow: '
    err.message = prefix + err.message
    newrelic.noticeError(err, {...getDefaultAttributes(), ...customAttributes})
  }
}

export class GVSAPICallError extends Error {
  constructor(url, method, status, response) {
    super(`API call error. URL: ${url}, method: ${method}, status: ${status}, response: ${JSON.stringify(response)}`)
    this.name = 'GVSAPICallError'
  }
}

export class WebsocketError extends Error {
  constructor(message) {
    super(message)
    this.name = 'WebsocketError'
  }
}

export class VignetteNotSupportedError extends Error {
  constructor(osFamily, osVersion) {
    super(`Vignette Visit Fail Start. OS: "${osFamily}", version: "${osVersion}". User Agent: "${window.navigator.userAgent}"`)
    this.name = 'VignetteNotSupportedError'
  }
}
